import { Divider, EditableText } from '@blueprintjs/core'
import { RematchRootState } from '@rematch/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'

import { connect } from 'react-redux'
import { CardContainer } from '../../components/Card'
import cardStyles from '../../components/Card/card.scss'
import LectureComment from '../../components/LectureComment'
import { dispatch, models, select, store } from '../../store'
// import LectureAudiences from '../LecturePage/lecture-audiences'
import LectureBriefEditor from '../LecturePage/lecture-brief-editor'
import LectureContent from '../LecturePage/lecture-content'
// import LectureMissions from '../LecturePage/lecture-missions'
// import LectureRequirements from '../LecturePage/lecture-requirements'
import LectureTeachers from '../LecturePage/lecture-teachers'
import styles from './../BeforeLaunchPage/before-launch.scss'

const cx = classnames.bind({ ...styles, ...cardStyles })

interface IProps extends ReturnType<typeof mapState> {
  lectureId: string
  isEdit: boolean
}

class Preview extends React.Component<IProps> {
  public componentDidMount = () => {
    const { lectureId } = this.props
    dispatch.stats.fetchStats(lectureId)
  }

  public render() {
    const rootState = store.getState()
    const { lectureId } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    // const participants = select.participants.getByLectureId(rootState, lectureId)
    const currentUser = firebase.auth().currentUser
    // const isSpeaker = lecture !== null && currentUser !== null && R.contains(currentUser.uid, lecture.speakerIds)
    // const isParticipant = currentUser !== null && participants !== null && R.contains(currentUser.uid, participants)
    const { isEdit } = this.props

    // tslint:disable-next-line
    if (R.isEmpty(lecture) || lecture === null) {
      return null
    }

    return (
      <CardContainer className={cx('page-before-launch-c__main')}>
        <div className={cx('header')}>
          <div className={cx('tag')}>{isEdit ? `編輯講座` : `互動講座`}</div>
          <h1 className={cx('title')}>
            {isEdit ? (
              <EditableText
                disabled={
                  currentUser
                    ? !R.contains(currentUser.uid, lecture.speakerIds)
                    : true
                }
                defaultValue={lecture.title}
                placeholder="講座名稱"
              />
            ) : (
              lecture.title
            )}
          </h1>
          <Divider className={cx('divider')} />
        </div>

        <div className={cx('main')}>
          <LectureBriefEditor
            lectureId={lectureId}
            isEdit={isEdit}
            content={lecture.description}
          />
          {/* <LectureMissions
            lectureId={lectureId}
            isEdit={isEdit}
            missions={lecture.missions}
          /> */}
          <LectureContent
            lectureId={lectureId}
            isEdit={isEdit}
            units={lecture.units}
            lecture={lecture}
          />
          <LectureTeachers
            lectureId={lectureId}
            isEdit={isEdit}
            lecture={lecture}
          />
          {/* <LectureAudiences
            lectureId={lectureId}
            isEdit={isEdit}
            targetAudiences={lecture.targetAudiences}
          />
          <LectureRequirements
            lectureId={lectureId}
            isEdit={isEdit}
            requirements={lecture.requirements}
          /> */}
          <LectureComment />
        </div>
      </CardContainer>
    )
  }
}

const mapState = ({ lectures, auth }: RematchRootState<models>) => ({
  lectures,
  auth
})
export default connect(mapState)(Preview)



// WEBPACK FOOTER //
// ./src/pages/LecturePage/preview.tsx